module.exports = __webpack_public_path__ + "static/img/homes2.9970efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes2.png
// module id = FGCm
// module chunks = 2